import _State from '@states/_State.js';
/**
 * this state manages the centralized active resource data.
 * currently, the viewer sets this resource, and the access control subscribes to it.
 * we can also set a new resource for the side-drawer when we click on a project or task.
 */
const ActiveResourceState = _State('activeResource', 'setActiveResource', {
  resource: null,
  resourceType: null,
  context: {},
  spaceType: 'personal',
});

export default ActiveResourceState;
